/**
 * UnitConversion is defined between 2 unit scales
 * The "user" scale is the one we requested from the units service
 * The "standard" scale is the SI for this type of measurement (defined in dimensionality)
 */
export interface UnitConversion {
  /** full label of the requested units */
  user_units: string;
  /** abbreviated label of the requested units */
  short_user_units: string;

  /** full label of the SI units */
  standard_units: string;
  /** abbreviated label of the SI units */
  short_standard_units: string;

  /** conversion parameters from requested units to SI units */
  scale: number;
  translate: number;

  /** what kind of units are these? (e.g., "[length]", "[temperature]") */
  dimensionality?: string | null;
}

export function createConversion(
  units: string,
  overrides?: Partial<UnitConversion>
): UnitConversion {
  return {
    user_units: units,
    standard_units: units,
    short_user_units: units,
    short_standard_units: units,
    scale: 1,
    translate: 0,
    ...overrides,
  };
}

export function getFormattedUnits(unitConversion: UnitConversion) {
  return unitConversion.short_user_units;
}

// A partial list of supported mass units can be found here
// https://github.com/CitrineInformatics/gemd-python/blob/main/gemd/units/citrine_en.txt#L217
export const MASS_UNITS = [
  "gram",
  "kilogram",
  "pound",
  "microgram",
  "milligram",
  "ounce",
  "metric_ton",
  "ton", // short_ton
  "microgram",
] as const;

export type MassUnit = (typeof MASS_UNITS)[number];
